import {
  Image as BaseImage,
  type ImageProps,
} from "@sphtech/sph-web-ui/elements/Image";
import { forwardRef } from "react";

export type {
  ImageObjectFit,
  ImageProps,
} from "@sphtech/sph-web-ui/elements/Image";

// Keep `loading="eager"` until `expectFullPageScreenshot` waits for images
// (roadmap PR 2); otherwise lazy images miss the screenshot capture window.
export const Image = forwardRef<HTMLImageElement, ImageProps>((props, ref) => (
  <BaseImage {...props} loading={props.loading ?? "eager"} ref={ref} />
));

Image.displayName = "Image";

export default Image;
